import { render, staticRenderFns } from "./FlatTire.vue?vue&type=template&id=307a7a1e"
import script from "./FlatTire.vue?vue&type=script&lang=js"
export * from "./FlatTire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports